import { App } from 'vue'
import Breadcrumbs from './LpBreadcrumbs.vue'

Breadcrumbs.install = (Vue: App) => {
  Vue.component(Breadcrumbs.name, Breadcrumbs)
}

export default Breadcrumbs
